import React from 'react'
import { DigitalAsset } from '../../../modules/domain/digitalAsset/types'
import { DeleteOutlined, DownloadOutlined, EditOutlined, MoreOutlined, RollbackOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Button, Dropdown } from 'antd'
import { useTranslation } from 'react-i18next'
import { useDigitalAssetActions } from '../../pages/DigitalAsset/hooks/useDigitalAssetActions'

type DADropdownProps = {
  digitalAsset: DigitalAsset
  canEditOrDelete: boolean
}

const DADropdownActions: React.FC<DADropdownProps> = ({ digitalAsset, canEditOrDelete }) => {
  const { t } = useTranslation('digitalAsset')

  // Use the consolidated action hook
  const {
    handleEdit,
    handleDownload,
    handleDelete,
    handleRestore,
    handlePermanentDelete,
    canDownload,
    isDeleted,
    contextHolder,
  } = useDigitalAssetActions({ digitalAsset, canEditOrDelete })

  // Active digital assets dropdown items
  const activeDropdownItems: MenuProps['items'] = [
    {
      key: '1',
      onClick: handleEdit,
      label: t('button.edit'),
      icon: <EditOutlined />,
      disabled: !canEditOrDelete,
    },
    {
      key: '2',
      onClick: handleDownload,
      label: t('button.download'),
      icon: <DownloadOutlined />,
      disabled: !canDownload,
    },
    {
      key: '3',
      onClick: handleDelete,
      label: t('button.delete'),
      icon: <DeleteOutlined />,
      disabled: !canEditOrDelete,
    },
  ]

  // Deleted digital assets dropdown items
  const deletedDropdownItems: MenuProps['items'] = [
    {
      key: '1',
      onClick: handleRestore,
      label: t('button.restore'),
      icon: <RollbackOutlined />,
    },
    {
      key: '2',
      onClick: handlePermanentDelete,
      label: t('button.delete_trash'),
      icon: <DeleteOutlined />,
    },
  ]

  // Determine which dropdown items to show based on status
  const dropdownItems: MenuProps['items'] = isDeleted ? deletedDropdownItems : activeDropdownItems

  return (
    <>
      {contextHolder}
      <Dropdown
        menu={{
          items: dropdownItems,
        }}
        trigger={['click']}
      >
        <Button type="text" icon={<MoreOutlined />} onClick={(e) => e.stopPropagation()} />
      </Dropdown>
    </>
  )
}
export default DADropdownActions
